import {connect} from 'react-redux';

import PostalCodeAddScreen from '../components/PostalCodeAddScreen';

const mapStateToProps = state => {
  return {
    isLoading: state.locationPostalCodes.get('arePostalCodesLoading'),
    success: state.locationPostalCodes.getIn(['form', 'success']),
  }
}

const PostalCodeAddScreenContainer = connect(
  mapStateToProps
)(PostalCodeAddScreen);

export default PostalCodeAddScreenContainer;
